module.exports = __webpack_public_path__ + "img/tree-04-g-leaves.32f00c3b.png";